import React from 'react'
import PropTypes from 'prop-types'
import Modal from "../Modal";

const Field = ({ label, value }) => (
  <div>
    <b>{label}</b> {value}
    <br />
  </div>
);

const Item = ({ isLast, audit }) => (
  <div>
    <p>
      <span
        className="grey-text"
        dangerouslySetInnerHTML={{ __html: audit.title }}
      />
    </p>
    {audit.values.map(({ label, value }, index) => (
      <Field key={index} label={label} value={value} />
    ))}
    {isLast ? null : <hr />}
  </div>
);

class History extends React.PureComponent {
  state = { visible: false };

  toggle = () =>
    this.setState({ visible: !this.state.visible });

  render() {
    const { visible } = this.state;
    const { history } = this.props;

    return (
      <React.Fragment>
        <button
          type="button"
          className="btn btn-indigo btn-raised btn-long margin-right-five"
          onClick={this.toggle}
        >
          VIEW HISTORY
        </button>

        <Modal
          title="Shift Report History"
          visible={visible}
          onClose={this.toggle}
        >
          {history.map((audit, index) => (
            <Item
              key={audit.id}
              audit={audit}
              isLast={index === history.length - 1}
            />
          ))}
        </Modal>
      </React.Fragment>
    );
  }
}

Field.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

Item.propTypes = {
  audit: PropTypes.object.isRequired,
  isLast: PropTypes.bool
};

Item.defaultProps = {
  isLast: false
};

History.propTypes = {
  history: PropTypes.array
};

History.defaulProps = {
  history: []
};

export default History;
